module.exports = __webpack_public_path__ + "static/media/glass3.6f03cc35.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass3.png
// module id = 728
// module chunks = 0